import { render, staticRenderFns } from "./PlanFour.vue?vue&type=template&id=51f22fb5&scoped=true&"
import script from "./PlanFour.vue?vue&type=script&lang=js&"
export * from "./PlanFour.vue?vue&type=script&lang=js&"
import style0 from "./PlanFour.vue?vue&type=style&index=0&id=51f22fb5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f22fb5",
  null
  
)

export default component.exports